export {
  pgnMovetextToSans,
  fenFromOpeningPgn,
  fenLineFromOpeningPgn,
  fenLineFromOpeningSans,
} from 'react-chess-core';

export const variationRowKey = (row: {
  opening: string;
  eco?: string;
}): string => `${row.opening}-${row.eco ?? ''}`;
